import {
    GET_ANAYTIC_DATA
  } from "../constants/ActionTypes";
  
  import update from "immutability-helper/index";
  
  const INIT_STATE = {
    loader: false,
    alertMessage: "",
    showMessage: false,
    topFiveUsedTempate: [],
    topFiveUsedApi: [],
    totalStackTillDate: 0,
    totalUserTillDate: 0,
    totalApiConnectorCount: 0,
    totalStacksCreatedTillDate: 0,
    totalAppCreatedCount: 0,
    realtimeActiveUsers: 0,
    dailyDistinctUsers: 0,
    dailyActiveStacks: 0,
    weeklyActiveStacks: 0,
    monthlyActiveStacks: 0,
    recentlyActiveStacks: [],
    onlineUsersList: [],
    totalWorkspaces: 0,
    paidWorkspaces: 0,
    freeWorkspaces: 0,
    paidUsers: 0,
    freeUsers: 0,
    errorType: "",
    message: "",
  };
  
  export default (state = INIT_STATE, action) => {
    switch (action.type) {
      case GET_ANAYTIC_DATA: {
        return {
          ...state,
          loader: true,
          topFiveUsedTempate: action.payload.top5Template,
          topFiveUsedApi: action.payload.top5Api,
          totalUserTillDate: action.payload.totalUser,
          totalStacksCreatedTillDate: action.payload.totalStack,
          totalApiConnectorCount: action.payload.totalApiConnectorCount,
          totalAppCreatedCount: action.payload.totalApp,
          realtimeActiveUsers: action.payload.realtimeActiveUsers || 0,
          dailyDistinctUsers: action.payload.dailyDistinctUsers || 0,
          dailyActiveStacks: action.payload.dailyActiveStacks || 0,
          weeklyActiveStacks: action.payload.weeklyActiveStacks || 0,
          monthlyActiveStacks: action.payload.monthlyActiveStacks || 0,
          recentlyActiveStacks: action.payload.recentlyActiveStacks || [],
          onlineUsersList: action.payload.onlineUsersList || [],
          totalWorkspaces: action.payload.totalWorkspaces || 0,
          paidWorkspaces: action.payload.paidWorkspaces || 0,
          freeWorkspaces: action.payload.freeWorkspaces || 0,
          paidUsers: action.payload.paidUsers || 0,
          freeUsers: action.payload.freeUsers || 0,
        };
      }
  
      default:
        return state;
    }
  };
  